<template>
    <span class="o-badge" :class="{ '-circle': circle }">
        <span><slot /></span>
    </span>
</template>

<script>
export default {
    name: "Badge",
    props: {
        circle: {
            type: Boolean,
            default: false,
        },
    },
};
</script>

<style lang="scss">
.o-badge {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    height: 2.5em;
    padding-right: 1em;
    padding-left: 1em;
    background-color: $color-bright;
    border-radius: 2em;

    &.-circle {
        width: 2.5em;
        padding: 0;
    }

    span {
        top: 0.09em;
        line-height: 1;
        font-family: ff("heavy");
        font-size: 1.3em;
    }
}
</style>
